import { render, staticRenderFns } from "./UnvergessenPolaroid.vue?vue&type=template&id=cf71b844&scoped=true"
import script from "./UnvergessenPolaroid.vue?vue&type=script&lang=js"
export * from "./UnvergessenPolaroid.vue?vue&type=script&lang=js"
import style0 from "./UnvergessenPolaroid.vue?vue&type=style&index=0&id=cf71b844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf71b844",
  null
  
)

export default component.exports